import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { PlantService } from '../../services/plant.service';
import { ReportService } from '../../services/report.service';
import { WeatherForecastService } from '../../services/weather-forecast.service';

@Component({
  selector: 'app-environmental',
  templateUrl: './environmental.component.html',
  styleUrls: ['./environmental.component.scss']
})
export class EnvironmentalComponent implements OnInit {

  navSwiper;
  swiper;
  currentDatetime;
  plantList = [];
  now = moment();
  currentYear = this.now.format('YYYY');
  currentMonth = this.now.format('MM');
  constructor(
    private weatherService: WeatherForecastService,
    private reportService: ReportService,
  ) { }

  ngOnInit(): void {
    setInterval(() => { this.currentDatetime = Date.now() }, 1000);
    this.initData();
    setInterval(() => { this.initData() }, 1 * 60 * 60 * 1000); //  one hour load once
  }

  initData() {
    this.now = moment().add(-1, 'days');
    this.currentYear = this.now.format('YYYY');
    this.currentMonth = this.now.format('MM');
    this.reportService.getLssPlantInfo().subscribe(resp => {
      const list = resp.data.result;
      console.log(`list >> ${JSON.stringify(list)}`);
      for (const plant of list) {
        plant.co2 = plant.yield / 1000 * 0.639;
        plant.carMileage = plant.yield * 2.669;
        plant.avgLightbulbs = plant.yield / 116.8;
        plant.waterConsumption = plant.yield * 1.9;
        plant.treesPlanted = plant.yield * 0.054;
        plant.lightbulbsPower = plant.yield * 0.48;

        this.weatherService.getWeatherForecast(plant.latitude, plant.longitude).subscribe(weatherResp => {
          const currentWeather = weatherResp;
          console.log(`weatherResp >> ${JSON.stringify(weatherResp)}`);
          const weather = currentWeather.weather[0];
          plant.weather = weather.main;
          plant.temperature = currentWeather.main.temp.toFixed(0);
          const hour = moment().hour();
          console.log(`hour >> ${hour}`)
          if (weather.id === 801) {
            if (hour >= 8 && hour <= 18) {
              plant.weatherIcon = 'assets/img/cloudy-sun.png';
            } else {
              plant.weatherIcon = 'assets/img/cloudy-moon.png';
            }
          } else {
            const findWeather = this.weatherService.WeatherType.find(w => w.name === plant.weather);
            if (findWeather) {
              plant.weatherIcon = findWeather.img;
            }
          }

          if (!plant.weatherIcon) {
            plant.weatherIcon = `http://openweathermap.org/img/wn/${weather.icon}@2x.png`;
          }

          const currentMonthDays = moment().add(-1, 'days').date();
          console.log(`plant.currMonthYield [${plant.name}] >> ${plant.currMonthYield}`);
          console.log(`currentMonthDays [${plant.name}] >> ${currentMonthDays}`);
          if (plant.capacity && currentMonthDays) {
            plant.avgSpecificYield = plant.currMonthYield / currentMonthDays / plant.capacity;
          }
        })
      }
      this.plantList = list;
    });
  }

  onNavSwiperInit(swiper) {
    this.navSwiper = swiper;
  }

  onSwiper(swiper) {
    this.swiper = swiper;
  }

}
